/* Built In Imports */
import NextLink from 'next/link';

import { Box, Flex, useTheme, Link } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import SingleLineText from '@msr/components/UI/SingleLineText';
import { render } from 'datocms-structured-text-to-html-string';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const Artists = ({ sectionContent, lang, region }) => {
  const theme = useTheme();

  return (
    <Box
      bgColor={'#03062C'}
      p={{ base: '60px 20px 60px 20px', lg: '60px 20px' }}
    >
      <MsrSectionTitle
        pt="0"
        mt="0"
        titleObj={sectionContent[0]}
        maxwidth={'900px'}
      />
      <ArtistCardGrid
        sectionContent={sectionContent[1]}
        title={{ fontSize: '26px', color: 'white.50' }}
        sessions={{ fontSize: '18px', color: 'yellow.100' }}
        desc={{ color: 'blue.200', pt: { base: '10px', md: '25px' } }}
        pageType="attend"
        lang={lang}
      />
    </Box>
  );
};

const ArtistCardGrid = ({
  sectionContent,
  title,
  sessions,
  desc,
  pageType,
  lang,
}) => {
  return (
    <Box
      mx="auto"
      maxW={{
        base: '302px',
        sm: '480px',
        md: '690px',
        lg: '1270px',
        xl: '1270px',
        "2xl": '1920px'
      }}
    >
      <Flex
        gridGap="15px"
        mx="auto"
        flexWrap={{ base: 'wrap', lg: 'nowrap' }}
        pt={'20px'}
        justifyContent="center"
        alignItems={'flex-start'}
      >
        {sectionContent?.cards?.map((secCon, _) => {
          return (
            <Box
              key={nanoid()}
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="flex-end"
              flexShrink="0"
              flexGrow="0"
              flexBasis={{
                base: '100%',
                md: '45%',
                lg: sectionContent?.cards?.length > 3 ? '24%' : '33%',
              }}
              pl="0.4rem"
              pr="0.4rem"
              pb={{ base: '50px', lg: 0 }}
              mx="auto"
              w={{
                base: '100%',
                sm: sectionContent?.cards?.length > 3 ? '230px' : '330px',
                md: sectionContent?.cards?.length > 3 ? '250px' : '350px',
                lg: sectionContent?.cards?.length > 3 ? '250px' : '370px',
              }}
              position="relative"
            >
              <LazyLoadImageComponent
                src={secCon.thumbnail?.url}
                alt={secCon.thumbnail?.alt}
                title={secCon.thumbnail?.title}
                pb={'15px'}
              />
              <Box
                color={desc.color}
                pt={desc.pt || 0}
                fontFamily="FedraSansStd-book"
                maxW={{ base: '250px', md: 'inherit' }}
              >
                <StructuredTextParser
                  str={render(secCon.description)}
                  mt="0"
                  textAlign="left"
                  fontStyle={desc.fontStyle}
                  lang={lang}
                  className="artist_details"
                />
              </Box>
            </Box>
          );
        })}
      </Flex>
      <style jsx global>
        {`
            .artist_details h3 {
                font-size: 20.89px;
                line-height; 31px;
                font-weight: 700;
                color: #FFF7E9;
                margin-bottom: 30px;
            }
            .artist_details h4 {
                font-size: 15px
                line-height; 23px;
                font-weight: 700;
                color: #FFF7E9;
                margin-bottom: 30px;
            }
            .artist_details p {
                font-size: 16px
                line-height; 27px;
                font-weight: 400;
                color: #FFFFFF;
            }                
        `}
      </style>
    </Box>
  );
};

export default Artists;
